import { useState } from "react";

import EditUser from "./editUser/EditUser";
import DeleteUser from "./deleteUser/DeleteUser";

import { IconButton, TableCell, TableRow, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { PLAN_NUMBER_OF_QR_MAP } from "../../../../utils/constants/Constants";

const UserRow = ({ adminUser, user, usergroups, setUsers }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const rowBody = (
    <>
      <TableCell component="th" align="center">
        <strong>{user._id}</strong>
      </TableCell>
      <TableCell align="center">{user.name}</TableCell>
      <TableCell align="center">{user.mail}</TableCell>
      <TableCell align="center">{user.phoneNumber}</TableCell>
      <TableCell align="center">
        {PLAN_NUMBER_OF_QR_MAP[user.subscriptionPlan]}
      </TableCell>
      <TableCell align="center">
        {user.role === "private" ? "Oui" : "Non"}
      </TableCell>
      <TableCell align="center">{user.isSubscribed ? "Oui" : "Non"}</TableCell>
      <TableCell align="center">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <IconButton
            onClick={() => {
              setIsEditOpen(true);
            }}
          >
            <EditIcon sx={{ color: "#027FA2" }} />
          </IconButton>
          <IconButton
            onClick={() => {
              setIsDeleteOpen(true);
            }}
          >
            <DeleteForeverIcon sx={{ color: "#C34D60" }} />
          </IconButton>
        </Box>
      </TableCell>
    </>
  );

  return (
    <>
      <TableRow>{rowBody}</TableRow>
      <EditUser
        adminUser={adminUser}
        user={user}
        usergroups={usergroups}
        isOpen={isEditOpen}
        setIsOpen={setIsEditOpen}
        setUsers={setUsers}
      />
      <DeleteUser
        adminUser={adminUser}
        user={user}
        isOpen={isDeleteOpen}
        setIsOpen={setIsDeleteOpen}
        setUsers={setUsers}
      />
    </>
  );
};

export default UserRow;
